import i18n from '@/locale'

const FieldsDef = {

  quotesPlugin: {
    columns: [
      {
        type: 'index',
        width: 50,
        align: 'center'
      },
      {
        key: 'title',
        title: 'Title',
        align: 'left',
        minWidth: 200
      },
      {
        key: 'data.quantity',
        title: 'Quantity',
        slot: 'propertyCell',
        align: 'left',
        minWidth: 90
      },
      {
        key: 'status',
        title: 'Status',
        align: 'left',
        minWidth: 80,
        render: (h, params) => {
          if (params.row.status) {
            return h('span', i18n.t('quote.status.' + params.row.status))
          }
        }
      },
      {
        key: 'created_at',
        title: 'Created',
        align: 'left',
        minWidth: 120
      },
      {
        title: 'Actions',
        key: 'actions',
        maxWidth: 150,
        minWidth: 80,
        align: 'center',
        render: (h, params) => {
          return h('Button', {
            props: {
              type: 'text'
            },
            on: {
              click: () => {
                // todo: instead of hardcode the path, uses $router may be safer.
                // Cannot use this.$router in common js module, to include the routers may not be the best solution.
                window.open(`/quotes/${params.row.id}`, '_blank')
              }
            }
          }, [h('Icon', { props: { type: 'md-create', size: 'small' } })])
        }
      }
    ]
  },
  bomPlugin: {
    columns: [
      {
        type: 'index',
        width: 50,
        align: 'center'
      },
      {
        key: 'part',
        title: i18n.t('product.plugins.bom.table.part_name'),
        render: (h, params) => {
          let partName = params.row.manufacturer_part?.chinese_name
          let partNum = params.row.manufacturer_part?.part_identity.part_number
          let displayName = `${partName} (${partNum})`
          return h('span', displayName)
        },
        width: 250
      },
      {
        key: 'name',
        title: i18n.t('product.plugins.bom.table.title'),
        align: 'left',
        width: 250,
        slot: 'name'
      },
      {
        key: 'version',
        title: i18n.t('product.plugins.bom.table.version'),
        align: 'left',
        slot: 'versionCell',
        maxWidth: 100
      },
      {
        key: 'note',
        title: i18n.t('product.plugins.bom.table.note'),
        align: 'left',
        render: (h, params) => {
          let sections = params.row.note.split('\n\n')
          return h('pre', sections[sections.length - 1])
        }
      },
      {
        key: 'action',
        title: i18n.t('product.plugins.bom.table.actions'),
        align: 'center',
        slot: 'actionCell',
        maxWidth: 100
      }
    ]
  }
}

export default FieldsDef
